import { SelectFilterOptionData } from "@design-system";
import {
  FindFilteredClients,
  FindFilteredClients_filteredClients_clients,
} from "../../graphql/types";
import { MapperFunction, useMappedQueryResult } from "../../graphql/query/use-mapped-query-result";
import { FILTERED_CLIENTS_QUERY } from "../../graphql/query";

const mapClientOption = ({
  id,
  name,
  externalReference,
}: FindFilteredClients_filteredClients_clients) => {
  const maybeWithExternalRef = externalReference ? `${name} - ${externalReference}` : name;
  return {
    value: id,
    label: maybeWithExternalRef,
    name: maybeWithExternalRef.toLowerCase(),
  };
};
const mapQueryResult: MapperFunction<FindFilteredClients, SelectFilterOptionData> = (
  queryResult
) => {
  return queryResult
    ? {
        clients: (queryResult!.filteredClients!.clients || []).map(mapClientOption),
        total: queryResult!.filteredClients!.total,
      }
    : undefined;
};

export const useFilteredClientSelectOptions = (
  nameFilter: string,
  options: {
    limit: number;
    offset: number;
  }
) => {
  const {
    loading,
    error,
    records,
    fetchMore: fetchMoreRaw,
    getClients,
  } = useMappedQueryResult(FILTERED_CLIENTS_QUERY, mapQueryResult, {
    filter: { search: nameFilter },
    ...options,
  });

  const { clients, total } = (records as {
    clients: SelectFilterOptionData[];
    total: number;
  }) || {
    clients: [],
    total: 0,
  };

  const fetchMore = clients.length < total ? fetchMoreRaw : undefined;

  return { loading, error, options: clients, fetchMore, getClients };
};
